// src/components/Collapsible/context.ts
import { createContext } from "react";
var CollapsibleContext = createContext({
  id: ""
});
export { CollapsibleContext };